export default __webpack_public_path__ + "static/media/heart_black.28166ab5.png";